import NavbarDashboard from "../../components/navbarDashboard/NavbarDashboard";
import * as React from "react";
import Typography from "@mui/material/Typography";
import { Stack } from "@mui/material";
import YearSelect from "../../components/YearSelector/YearSelect";
import CardDashboard from "../../components/CardDisplay/CardDashBoard";

const AdminPageReport = () => {
  const currentMonth = new Date().getMonth() + 1; // 1–12
  const currentYear  = new Date().getFullYear();
  const currentHalf  = currentMonth <= 6 ? 1 : 2; // 1 = APR-MAY-JUN, 2 = JUL-AUG-SEP

  const [reportData, setReportData] = React.useState([]);
  const [year, setYear]             = React.useState(currentYear.toString());

  const updateYear = (value) => setYear(value);

  // ── year-aware card state ─────────────────────────────────────────────────
  const selectedYearNum = parseInt(year, 10);
  const isPastYear      = selectedYearNum < currentYear;
  const isFutureYear    = selectedYearNum > currentYear;
  const isCurrentYear   = selectedYearNum === currentYear;

  /*
    DOWNLOAD RULES:
    - Past year         → both halves downloadable, nothing else
    - Current year      → active half: all enabled | past half: download only
    - Future year       → nothing at all

    EDIT / CREATE / EXTEND RULES:
    - Only the currently active half of the current year
  */

  const half1Active       = isCurrentYear && currentHalf === 1;
  const half2Active       = isCurrentYear && currentHalf === 2;
  const half1PastThisYear = isCurrentYear && currentHalf === 2; // half 1 already closed

  // isDownload: true for past year (both), current year active+past half, NOT future
  const half1Download = !isFutureYear && (isPastYear || half1Active || half1PastThisYear);
  const half2Download = !isFutureYear && (isPastYear || half2Active);

  // isEdit / isReport: only the active half of the current year
  const half1Edit   = half1Active;
  const half2Edit   = half2Active;
  const half1Report = half1Active;
  const half2Report = half2Active;

  // Stage label — past year both show "Closed", future shows "Closed" too
  const half1Stage = half1Active ? "New" : "Closed";
  const half2Stage = half2Active ? "New" : "Closed";

  // ── fetch ─────────────────────────────────────────────────────────────────
  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/admin/report/${year}/JUL-AUG-SEP`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("jwt")}`,
            },
          }
        );
        const data = await res.json();
        setReportData(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("Fetch error:", err);
        setReportData([]);
      }
    };
    fetchData();
  }, [year]);

  // Context hint
  const hintText = isPastYear
    ? "← Past Year · Download Only"
    : isFutureYear
    ? "Future Year · No Data"
    : `Active Year · Half ${currentHalf} Open`;

  return (
    <div>
      <NavbarDashboard />

      {/* Year selector — top right */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "7%",
          marginRight: "5%",
        }}
      >
        <YearSelect yearUpdate={updateYear} />
      </div>

      {/* Main layout */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          height: "100vh",
        }}
      >
        {/* Left label */}
        <div style={{ marginLeft: "15%", marginTop: "4%" }}>
          <Typography
            variant="h4"
            sx={{ color: "#fff", fontFamily: "Montserrat, sans-serif" }}
          >
            HALF YEARLY
          </Typography>
          <Typography
            variant="h3"
            sx={{ color: "#79DCFF", fontFamily: "Montserrat, sans-serif" }}
          >
            SELECTOR
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "rgba(121,220,255,0.6)",
              fontFamily: "Montserrat, sans-serif",
              mt: 1,
              fontSize: "0.78rem",
              letterSpacing: "0.08em",
            }}
          >
            {hintText}
          </Typography>
        </div>

        {/* Cards */}
        <div style={{ marginRight: "20%", marginTop: "4%" }}>
          <Stack direction="row" spacing={2}>

            {/* HALF 1 — APR-MAY-JUN */}
            <CardDashboard
              currentYear={year}
              id={reportData[0]?.report?.id || ""}
              index={1}
              stage={half1Stage}
              currentQuarter="APR-MAY-JUN"
              isEdit={half1Edit}
              isDownload={half1Download}
              isReport={half1Report}
            />

            {/* HALF 2 — JUL-AUG-SEP */}
            <CardDashboard
              currentYear={year}
              id={reportData[0]?.report?.id || ""}
              index={2}
              stage={half2Stage}
              currentQuarter="JUL-AUG-SEP"
              isEdit={half2Edit}
              isDownload={half2Download}
              isReport={half2Report}
            />

          </Stack>
        </div>
      </div>
    </div>
  );
};

export default AdminPageReport;